import type { PdfExtractorOptions } from '../types';
import { withSBErrorHandling } from '../types';

import { ScanbotSDKPlugin } from './Definitions';

/**
 * @internal
 * @hidden
 */
export const ScanbotPdfImageExtractorImpl = {
  async extractImageFiles(params: { pdfFileUri: string; options?: PdfExtractorOptions }): Promise<string[]> {
    return withSBErrorHandling(async () => {
      return (await ScanbotSDKPlugin.extractImageFilesFromPdf(params)).result;
    });
  },
};
